export default __webpack_public_path__ + "static/NotoSansTifinagh-Regular-552ce360496b44ddb53b50757fc172c5.woff2";